<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">At The Sign Of The Golden Pineapple</h1>
<p class="right1">M. C. Beaton/ Marion Chesney</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795320729_epub_tp_r1.vue?6bf94c7e